"use client";

import { motion } from "framer-motion";

export default function Oportunidade() {
  return (
    <section
      id="programa"
      className="relative bg-blue-dark pt-20 lg:pt-0 pb-32 overflow-hidden -mt-12 z-20"
    >
      <div className="lg:hidden absolute top-0 left-0 w-full h-40 bg-gradient-to-b from-blue-dark to-transparent z-[5] pointer-events-none" style={{ marginTop: "-160px" }} />

      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full z-0 pointer-events-none flex justify-end items-start opacity-70 transform rotate-180">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/images/formacao-devs-ia/Pixels.png" alt="" className="object-contain max-h-full" />
      </div>

      <motion.div
        animate={{ y: [-15, 15, -15] }}
        transition={{ repeat: Infinity, duration: 8, ease: "linear" }}
        className="hidden lg:block absolute top-[5%] right-[2%] lg:right-[4%] text-white font-mono text-xs md:text-sm whitespace-pre select-none pointer-events-none z-10 opacity-15"
      >
        {`import future from agibank
import ai_models as ai

def start_journey(dev):
    dev.upgrade(skills=["Code", "AI", "Impact"])
    return "Limitless"

# system.init(career_mode="ON")`}
      </motion.div>

      <motion.div
        animate={{ y: [-20, 20, -20] }}
        transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
        className="hidden lg:block absolute top-10 left-[2%] text-white text-6xl md:text-8xl font-light select-none pointer-events-none z-10 opacity-60"
      >
        &lt;
      </motion.div>

      <motion.div
        animate={{ y: [20, -20, 20] }}
        transition={{ repeat: Infinity, duration: 7, ease: "linear" }}
        className="absolute bottom-20 right-[2%] text-white text-5xl md:text-7xl font-light select-none pointer-events-none z-10 opacity-60"
      >
        /&gt;
      </motion.div>

      <div className="container-custom relative z-20">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="max-w-[950px]"
        >
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-bold text-secondary-main mb-10 leading-tight">
            A sua oportunidade de se tornar um DEV habilitado em IA
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-white/90 font-light leading-relaxed mb-12">
            <p>
              A Formação de Devs nativos em IA é para pessoas que já usam
              a Inteligência Artificial como parte essencial do dia a dia e querem atuar na área
              de tecnologia de forma agilizada, praticando o {" "}
              <span className="font-bold text-secondary-main">
                desenvolvimento de software aliado à IA {" "}
              </span>desde o dia um.
            </p>
            <p>
              Com uma verdadeira imersão na teoria e na prática, você passa por{" "}
              <span className="font-bold text-secondary-main">
                6 meses de treinamento em Java + IA, recebendo uma bolsa-auxílio de R$ 2.400,
              </span>{" "}
              podendo seguir para a 2ª etapa e fazer parte de uma das nossas squads.
            </p>
            <p>
              Buscamos talentos que não têm medo de superar desafios para construir uma carreira com entregas que realmente impactam o crescimento do negócio.
            </p>
            <p>
              Então, se você quer aprender muito e aplicar o seu conhecimento em uma empresa que cresce junto com você,{" "}
              <span className="font-bold text-secondary-main">o Agibank é o seu lugar!</span>
            </p>
          </div>

          <a
            href="https://job-boards.greenhouse.io/agibank/jobs/5270544008"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-secondary-main text-blue-dark px-10 py-4 rounded-full font-bold text-lg hover:bg-blue-main hover:text-white transition-all transform hover:scale-105 active:scale-95 shadow-[0_0_20px_rgba(119,223,64,0.2)]"
          >
            Quero me tornar Dev do Agi
          </a>
        </motion.div>
      </div>
    </section>
  );
}
